;(() => {
  if (customElements.get('component-hero')) {
    return
  }

  class ComponentHero extends HTMLElement {
    constructor() {
      super()

      this.initSliderHandler = this.initSlider.bind(this)
      this.$scrollDown = this.querySelector('.js-scroll-down')
    }

    connectedCallback() {
      this.initSliderHandler()
      this.addEvents()
    }

    initSlider() {
      const sliders = this.querySelectorAll('.splide')

      if (!sliders) {
        return
      }

      sliders.forEach((slider) => {
        new Splide(slider, {
          arrows: false,
          pagination: false,
          drag: false,
          rewind: true,
          autoplay: [true, 'true'].includes(slider.dataset.autoplay),
          interval: slider.dataset.interval,
          lazyLoad: false,
          type: slider.dataset.effect,
        }).mount()
      })
    }

    addEvents() {
      if (this.$scrollDown) {
        this.$scrollDown.addEventListener(
          'click',
          this.scrollToNextSection.bind(this)
        )
      }
    }

    scrollToNextSection() {
      const $section = this.$scrollDown.closest('.shopify-section')
      const $nextSection = $section.nextElementSibling

      this.$scrollDown.classList.add(
        'hero__actions-down--hide',
        'visibility-hidden'
      )

      $nextSection &&
        window.scrollTo({
          top: $nextSection.offsetTop,
          left: window.scrollX,
          behavior: 'smooth',
        })
    }
  }

  customElements.define('component-hero', ComponentHero)
})()
